import { render, staticRenderFns } from "./ContractsRecordView.vue?vue&type=template&id=19a59f30&scoped=true"
import script from "./ContractsRecordView.vue?vue&type=script&lang=js"
export * from "./ContractsRecordView.vue?vue&type=script&lang=js"
import style0 from "./ContractsRecordView.vue?vue&type=style&index=0&id=19a59f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a59f30",
  null
  
)

export default component.exports